import { render, staticRenderFns } from "./CommingSoon.vue?vue&type=template&id=ce89ac22&scoped=true&"
import script from "./CommingSoon.vue?vue&type=script&lang=ts&"
export * from "./CommingSoon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce89ac22",
  null
  
)

export default component.exports